import Layout from 'components/layout';
import SEO from 'components/seo';
import { StickyProvider } from 'contexts/app/app.provider';
import React from 'react';
import Feature01 from 'sections/01-feature';
import Feature02 from 'sections/02-feature';
import Feature03 from 'sections/03-feature';
import Feature04 from 'sections/04-feature';
import Banner from 'sections/banner';
import ClientCard from 'sections/client';
import ClientSection from 'sections/client-section';
import KeyFeature from 'sections/key-feature';
import NewsCard from 'sections/news';

// Load other package css file
import 'rc-drawer/assets/index.css';
import 'react-modal-video/css/modal-video.min.css';
import 'react-multi-carousel/lib/styles.css';
import SectionHeader from '../components/section-header';

export default function IndexPage() {
  return (
    <StickyProvider>
      <Layout>
        <SEO title="PT. Pinisi Elektra" />
        <Banner />
        <KeyFeature />
        <SectionHeader
            slogan="Solution & Product"
            title="Your Next Breakthrough Is a Click Away."
        />
        <Feature01 />
        {/* <WorkFlow /> */}
        <Feature02 />
        <Feature03 />
        <Feature04 />

        <ClientSection />
        <ClientCard />
        <NewsCard />
      </Layout>
    </StickyProvider>
  );
}
